export const Colors = {
  COMPANIES_ACQUIRED_BORDER: "#8BC34A",
  COMPANIES_NEW_BORDER: "#FFFAA0",
  COMPANIES_PAST_BORDER: "#f7682a",
  COMPANIES_FUTURE_BORDER: "#84bffb",
};
